/**
 * 
 * demo.js
 * 
 */

 import React, { Component } from 'react'

 // component
 import Body from './body/Body';
 
 export default class Demo extends Component {

    static displayName = Demo.name;


     render() {


         return (


             <Body />


         );


     }


 }

